import styled from "styled-components";

import { Select } from "pages/[tenant]/console/components/molecules/ConsolePageForm/atoms/ConsolePageSelect/styles";

export const TopBarActionsContainer = styled.div`
  margin-top: 5rem;
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;

  .arrow-text {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    h1 {
      font-family: Inter;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%; /* 22.5px */
      color: ${({ theme }) => theme.console.sidebar.titleColor} !important;
      margin-bottom: 0;
    }

    svg * {
      color: ${({ theme }) => theme.console.sidebar.titleColor} !important;
    }
  }

  .action-buttons {
    display: flex;
    gap: 0.75rem;
  }

  ${Select} {
    height: 0;
  }

  .save-button {
    svg * {
      font-size: 2rem;
    }
  }

  @keyframes loading {
    to {
      transform: rotate(0);
    }
    from {
      transform: rotate(360deg);
    }
  }

  .loader-apply {
    color: ${({ theme }) => theme.groups.primaryText};
    animation: loading 1s linear infinite;
    font-size: 1.125rem;
    margin: 0 1.25rem;
    height: 1rem;
    width: 1rem;
  }

  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: ${({ theme }) =>
      theme.console.backgroundColor} !important;
    margin-top: 0;
    position: fixed;
    width: 95%;
    padding: 1rem 0;
    z-index: 10;

    .cancel-button,
    .create-button {
      width: 100%;
    }
  }
`;
